import environment from 'app/config/environment';

export const TRANSACTION_TYPE_OPTIONS = (type: string) => {
  switch (type) {
    case 'PURCHASE':
      return 'Buy';
    case 'LISTING':
      return 'List';
    case 'LEASE_OFFER':
      return 'Lease Offer';
    case 'LEASE_LISTING':
      return 'Lease List';
    default:
      return type || '-';
  }
};

export const TRANSACTION_TYPE_MAP =
  environment.nodeEnvironment.ENV === 'test' ||
  environment.nodeEnvironment.ENV === 'staging'
    ? {
        PURCHASE: 'Buy',
        LISTING: 'List',
        LEASE_OFFER: 'Lease Offer',
        LEASE_LISTING: 'Lease List',
      }
    : {
        PURCHASE: 'Buy',
        LISTING: 'List',
      };

export const TRANSACTION_TYPES = [
  'PURCHASE',
  'LISTING',
  'LEASE_OFFER',
  'LEASE_LISTING',
];
